<div class="page-content-container">
  <div class="header-container">
    <app-datasafra-search
      (search)="handleSearch($event)"
    ></app-datasafra-search>
    <button
      mat-flat-button
      extended
      [disabled]="canCreateRequest() === false"
      (click)="navigateToCreationPage()"
    >
      <mat-icon>add</mat-icon>
      Solicitar análise
    </button>
  </div>
  <app-requests-table
    [dataSource]="dataSource"
    [isLoading]="isLoading"
    [length]="length"
    [config]="tableConfig"
    [actions]="tableActions"
    (sortChange)="handleSort()"
    (pageChange)="handlePage()"
    (refresh)="handlePage()"
    (rowToggle)="toggle($event)"
  >
    <ng-template #expandedDetailTemplate let-el>
      @let element = asTypedItem(el);
      <div class="requests-element-diagram">
        <div class="requests-detail-row">
          <span>
            <b>Nº de relatórios desta solicitação:</b>
            {{ element.featureCount ?? "—" }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Nº total de relatórios solicitados e executados:</b>
            {{ element.requestedAndExecutedReportsCount ?? "—" }}
          </span>
        </div>
        <div class="requests-detail-row">
          <span>
            <b>Status da solicitação:</b>
            {{ element.status.description }}
          </span>
        </div>
        @if (["COMPLETED", "FAILED"].includes(element.status.code)) {
          <div class="requests-detail-row">
            <span>
              <b>Data do evento:</b>
              {{ element.lastModifiedDate | date: "dd/MM/yyyy HH:mm:ss" }}
            </span>
          </div>
        }
        @if (element.status.code === "FAILED") {
          <div class="requests-detail-row">
            <span>
              <b>Motivo do cancelamento:</b>
              {{ element.error ?? "—" }}
            </span>
          </div>
        }

        <div class="requests-detail-row">
          <span
            [ngSwitch]="getExtensao(element.originalFileName)"
            style="display: flex; align-items: center; gap: 8px"
          >
            <b>Tipo de Dado:</b>

            <ng-container *ngSwitchCase="'xlsx'">Planilha Excel</ng-container>
            <ng-container *ngSwitchCase="'xls'">Planilha Excel</ng-container>

            <ng-container *ngSwitchCase="'kml'"
              >KML (Google Earth)</ng-container
            >
            <ng-container *ngSwitchCase="'kmz'"
              >KMZ (Google Earth)</ng-container
            >

            <ng-container *ngSwitchCase="'shp'">Shapefile</ng-container>
            <ng-container *ngSwitchCase="'zip'"
              >Shapefile / Arquivo Compactado</ng-container
            >

            <ng-container *ngSwitchDefault
              >Outro formato ({{
                getExtensao(element.originalFileName)
              }})</ng-container
            >
          </span>
        </div>

        <div class="requests-detail-row" style="grid-column: span 2">
          <span style="display: flex; align-items: center; gap: 8px">
            <b>Arquivo:</b>
            <a href="{{ element.linkToDownload }}">{{
              element.originalFileName
            }}</a>
            <a
              mat-icon
              class="download-button"
              href="{{ element.linkToDownload }}"
            >
              <mat-icon>download</mat-icon>
            </a>
          </span>
        </div>
      </div>
    </ng-template>
  </app-requests-table>
</div>
